import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { Box, Button, CircularProgress, FormControl, FormHelperText, InputLabel, Paper, Select, TextField, ThemeProvider, Typography } from '@material-ui/core';
import moment from 'moment';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetFormattedDate } from '../../../../services/helpers.js';
import { Dialog, AppBar, Toolbar, Checkbox, FormControlLabel, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Redirect } from 'react-router-dom';
import { SelectTheme } from '../../../../utils/utils.js';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import appFetch from '../../../../api/appFetch.js';
import OutletUsersDropdown from '../../../Common/Dropdowns/OutletUsersDropdown.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import AgendasDropdown from '../../../Common/Dropdowns/AgendasDropdown.js'
import { LinkedWorkshopAgendasUrl, LinkedWorkshopAgendasWithIdUrl, LinkedWorkshopAgendasWithOutletIdUrl, OutletUsersNotDeletedUrl, WorkshopAgendasUrl } from '../../../../constants/apiUrls.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';
import { withPlanningSettings } from '../../../../utils/withPlanningSettings.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class LinkAgendaNew extends Component {

    constructor(props) {
        super(props);

        let receivedOutletId;

        if (this.props.location?.state?.outletId !== undefined) {
            receivedOutletId = parseInt(this.props.location?.state?.outletId)
        }
        else if (this.props.match.params.outletId) {
            receivedOutletId = parseInt(this.props.match.params.outletId)
        }

        this.state = {
            id: 0,
            loading: false,
            moboOutletId: receivedOutletId,
            outletUserId: 0,
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            outletUsers: this.props.outletUsers !== undefined ? this.props.outletUsers : [],
            editedLinkAgendaId: this.props.linkagendaId,
            agendaId: 0,
            agendas: this.props.agendas !== undefined ? this.props.agendas : [],
            activeFrom: "",
            activeTill: "",
            hasNoAvailability: false,
            requestInProgress: false,
            openEditPopup: true,
            showEditLinkAgenda: false,
            redirect: null,
            linkAgendasWasCreated: false,
            linkAgendasItems: this.props.linkAgendasItems !== undefined ? this.props.linkAgendasItems : [],
        };

        // Notify the HOC about the initial outlet
        if (this.props.onOutletChangeForSettings && receivedOutletId) {
            this.props.onOutletChangeForSettings(receivedOutletId);
        }
    }

    componentDidMount() {
        if (this.props.accessibleMoboOutlets !== undefined) {
            const outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description.toLowerCase().localeCompare(b.description.toLowerCase())))

            if (this.state.moboOutletId === undefined) {
                this.setState({ moboOutletId: outlets[0].id });
            }
        }

        if (this.state.editedLinkAgendaId !== undefined) {
            if (this.props.accessibleMoboOutlets != undefined) {
                let outletIdExists = false;
                this.props.accessibleMoboOutlets.forEach(element => {
                    if (element.id === this.state.moboOutletId) {
                        outletIdExists = true;
                    }
                });
                if (outletIdExists === false) {
                    this.setState({ loading: false, redirect: "/" });
                }
                else {
                    this.getLinkAgendaById(this.state.linkAgendasItems, parseInt(this.state.editedLinkAgendaId), this.state.moboOutletId);
                }
            }
        }
    }

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleActiveFrom = value => {
        this.setState({ activeFrom: value });
    };

    handleActiveTill = value => {
        this.setState({ activeTill: value });
    };

    handleSubmit = () => {
        if (this.state.id == 0) {
            this.saveNewLinkAgenda();
        }
        else {
            this.saveEditedLinkAgenda();
        }
    }

    getLinkAgendaById = (linkAgendasItems, editedLinkAgendaId, outletId) => {

        if (linkAgendasItems.length > 0) {
            linkAgendasItems.forEach(item => {
                if (item.id === editedLinkAgendaId) {
                    this.setState({
                        id: item.id,
                        activeFrom: GetFormattedDate(item.activeFrom),
                        activeTill: GetFormattedDate(item.activeTill),
                        loading: false,
                        modifiedOn: item.modifiedOn,
                        modifiedByName: item.modifiedBy !== null ? item.modifiedBy.firstName + " " + item.modifiedBy.lastName : "",
                        modifiedByAvatar: item.modifiedBy.avatar,
                        moboOutletId: item.outlet.moboOutletId,
                        outletUserId: item.outletUser.outletUserId,
                        agendaId: item.workshopPlanningAgenda.id,
                        hasNoAvailability: item.hasNoAvailability
                    });
                }
            });
        } else {
            this.setState({ requestInProgress: true });
            appFetch({
                url: LinkedWorkshopAgendasWithOutletIdUrl(outletId),
                onSuccess: (data) => {
                    let existsAgendaItem = false;
                    let item = null;

                    data.forEach(function (row) {
                        if (row.id === editedLinkAgendaId) {
                            existsAgendaItem = true;
                            item = row;
                        }
                    });

                    if (existsAgendaItem) {
                        this.setState({
                            id: item.id,
                            activeFrom: GetFormattedDate(item.activeFrom),
                            activeTill: GetFormattedDate(item.activeTill),
                            loading: false,
                            modifiedOn: item.modifiedOn,
                            modifiedByName: item.modifiedBy !== null ? item.modifiedBy.firstName + " " + item.modifiedBy.lastName : "",
                            modifiedByAvatar: item.modifiedBy.avatar,
                            moboOutletId: item.outlet.moboOutletId,
                            outletUserId: item.outletUser.outletUserId,
                            agendaId: item.workshopPlanningAgenda.id,
                            hasNoAvailability: item.hasNoAvailability
                        });
                    }
                    else {
                        this.setState({ loading: false, open: false, redirect: "/" });
                    }
                },
                onError: (data) => {
                    for (let i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }
    }

    validateData = (activeFrom, activeTill) => {
        var resources = this.props.resources;
        var isValid = true;

        if (this.state.outletUserId < 0) {
            DisplayMessage(resources["InvalidOutletUser"], "error");
            isValid = false;
        }

        if (this.state.agendaId < 0) {
            DisplayMessage(resources["InvalidAgenda"], "error");
            isValid = false;
        }
        if (activeFrom >= activeTill) {
            DisplayMessage(resources["InvalidEndDate"], "error");
            return false;
        }
        return isValid;
    }

    isValidForm = () => {
        const { outletUserId, agendaId, activeFrom, activeTill } = this.state;

        if (!outletUserId || outletUserId < 0) {
            return false;
        }

        if (!agendaId || agendaId < 0) {
            return false;
        }

        if (!activeFrom || !activeTill) {
            return false;
        }

        const momentActiveFrom = moment(activeFrom, "YYYY/MM/DD");
        const momentActiveTill = moment(activeTill, "YYYY/MM/DD");

        if (!momentActiveFrom.isValid() || !momentActiveTill.isValid() || momentActiveTill.isBefore(momentActiveFrom)) {
            return false;
        }

        return true;
    }

    saveNewLinkAgenda = () => {
        let activeFrom = GetFormattedDate(this.state.activeFrom == "" ? undefined : this.state.activeFrom);
        let activeTill = GetFormattedDate(this.state.activeTill == "" ? undefined : this.state.activeTill);

        let resources = this.props.resources;
        if (!this.validateData(activeFrom, activeTill)) {
            return;
        }

        var json = JSON.stringify({
            outletUserId: this.state.outletUserId,
            moboOutletId: this.state.moboOutletId,
            workshopPlanningAgendaId: this.state.agendaId,
            activeFrom: activeFrom,
            activeTill: activeTill,
            hasNoAvailability: this.state.hasNoAvailability,
        });

        const url = LinkedWorkshopAgendasUrl();

        this.setState({ requestInProgress: true });

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data, response) => {
                DisplayMessage(resources["NewLinkAgendaWasSaved"], "success");
                this.setState({ openEditPopup: false, redirect: "/linkagendas", agendasWasCreated: response.ok, linkAgendasWasCreated: true });
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    saveEditedLinkAgenda = () => {
        let activeFrom = GetFormattedDate(this.state.activeFrom == "" ? undefined : this.state.activeFrom);
        let activeTill = GetFormattedDate(this.state.activeTill == "" ? undefined : this.state.activeTill);

        let resources = this.props.resources;
        if (!this.validateData(activeFrom, activeTill)) {
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            activeFrom: activeFrom,
            activeTill: activeTill,
            hasNoAvailability: this.state.hasNoAvailability,
        });

        const url = LinkedWorkshopAgendasWithIdUrl(this.state.id);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (data, response) => {
                DisplayMessage(resources["LinkAgendaWasSaved"], "success");
                this.setState({ updateInProgress: false, redirect: (response.ok ? '/linkagendas' : null), linkAgendaWasEdited: response.ok, linkAgendasWasCreated: true });
                this.handleClose();
            },
            onError: (data) => {
                const errors = data.errors;

                for (let i = 0; i < errors.length; i++) {
                    DisplayMessage(errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderModifiedByInfo = () => {
        let resources = this.props.resources;
        if (this.state.id > 0) {
            return (
                <ModifiedByInfo
                    resources={resources}
                    modifiedByAvatar={this.state.modifiedByAvatar}
                    modifiedOn={this.state.modifiedOn}
                    modifiedByName={this.state.modifiedByName}
                    className="mt-3"
                />
            );
        }

        return;
    }

    handleClose = () => {
        this.setState({ loading: false, redirect: "/linkagendas" });
    }

    handleChangeOutlet = e => {
        const id = e.target.value;
        this.setState({ moboOutletId: id }, () => {
            // Notify the HOC about the outlet change to fetch new settings
            if (this.props.onOutletChangeForSettings) {
                this.props.onOutletChangeForSettings(id);
            }
        });
    };

    handleChangeOutletUser = e => {
        this.setState({ outletUserId: parseInt(e.target.value) });
    };

    handleChangeAgenda = e => {
        this.setState({ agendaId: parseInt(e.target.value) });
    };

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleSubmit();
    };

    renderForm() {
        const { redirect, requestInProgress, hasNoAvailability, openEditPopup,
            editedLinkAgendaId, linkAgendasWasCreated, moboOutletId, outletUserId,
            agendaId, activeFrom, activeTill } = this.state;
        const { resources } = this.props;
        const canEdit = this.props.canUseAgendasAndAbsencesInSettings !== false;
        // isEditMode: certain fields (outlet, user, agenda) can't be changed when editing an existing record
        const isEditMode = editedLinkAgendaId > 0;
        var helperTextActiveFrom = activeFrom === "" ? "helper-text-red" : "helper-text-grey";
        var helperTextActiveTill = activeTill === "" ? "helper-text-red" : "helper-text-grey";


        if (redirect) {
            return <Redirect to={{ pathname: this.state.redirect, state: { linkAgendasWasCreated, refreshGrid: linkAgendasWasCreated } }} />
        }

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect || !canEdit

        return (
            <Dialog fullScreen open={openEditPopup} onClose={this.handleClose} TransitionComponent={Transition}>
                <Form onSubmit={this.handleFormSubmit} >

                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton edge="start" id="close-edit-agenda" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {editedLinkAgendaId !== undefined ? resources["EditLinkAgenda"] : resources["AddNewLinkAgendaTitle"]}
                            </Typography>
                            <Button id="linked-indicators-save" color="inherit" type="submit" disabled={isSaveButtonDisabled}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>

                    <div className="container">
                        <div className="py-4 grey">
                            {!canEdit && (
                                <Typography variant="body2" color="error" align="center" style={{ marginBottom: 0 }}>
                                    {resources["UseShiftsFunctionalityToManageAgendasOrAbsences"]}
                                </Typography>
                            )}
                            <Paper elevation={3} className="p-4 mt-3 mb-3">
                                <Form.Group className="pt-3" style={{ display: "flex" }}>
                                    <div className="col-md-3"></div>
                                    <OutletsDropdown
                                        resources={resources}
                                        outlets={this.props.accessibleMoboOutlets}
                                        outlet={moboOutletId}
                                        onOutletChange={this.handleChangeOutlet}
                                        containerClass="col-md-6"
                                        noPlaceholder
                                        disabled={isEditMode}
                                    />
                                </Form.Group>
                                <Form.Group style={{ display: "flex" }}>
                                    <div className="col-md-3"></div>
                                    <OutletUsersDropdown
                                        resources={resources}
                                        outletUser={outletUserId}
                                        onOutletUserChange={this.handleChangeOutletUser}
                                        onRequestStart={() => this.setState({ requestInProgress: true })}
                                        onRequestEnd={() => this.setState({ requestInProgress: false })}
                                        containerClass="col-md-6"
                                        helperText={resources["OutletUserHelperText"]}
                                        disabled={isEditMode || !canEdit}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group style={{ display: "flex" }}>
                                    <div className="col-md-3"></div>
                                    <AgendasDropdown
                                        resources={resources}
                                        agenda={this.state.agendaId}
                                        onAgendaChange={this.handleChangeAgenda}
                                        onRequestStart={() => this.setState({ requestInProgress: true })}
                                        onRequestEnd={() => this.setState({ requestInProgress: false })}
                                        containerClass="col-md-6"
                                        helperText={resources["AgendaHelperText"]}
                                        disabled={isEditMode || !canEdit}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group style={{ display: "flex", width: "100%", justifyContent: "center" }}  >
                                    <Box display="flex" justifyContent="space-between" className='col-6' padding="0" gap="15px">
                                        <DatePickerComponent
                                            id="dateActiveFrom"
                                            label={resources["ActiveFrom"]}
                                            value={activeFrom}
                                            onChange={this.handleActiveFrom}
                                            error={!activeFrom}
                                            helperText={resources["PleasePickADate"]}
                                            minDate={new Date("2014-09-08")}
                                            dateFilter={(date) => date.getDay() !== 1}
                                            required
                                            disabled={!canEdit}
                                        />
                                        <DatePickerComponent
                                            id="dateActiveTill"
                                            label={resources["ActiveTill"]}
                                            value={activeTill}
                                            onChange={this.handleActiveTill}
                                            error={!activeTill}
                                            helperText={resources["PleasePickADate"]}
                                            minDate={new Date("2014-09-07")}
                                            dateFilter={(date) => date.getDay() !== 0 || (activeFrom && date < new Date(activeFrom))}
                                            required
                                            disabled={!canEdit}
                                        />
                                    </Box>
                                </Form.Group>
                                <Form.Group className="d-flex" >
                                    <div className="col-md-3 "> </div>
                                    <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                                        control={<Checkbox id="agendas-has-no-availability" checked={hasNoAvailability} onChange={this.handleChangeCheckBox} name="hasNoAvailability" color="primary" disabled={!canEdit} />}
                                        label={resources["HasNoAvailability"]} />
                                    <div className="col-md-4"> </div>
                                </Form.Group>
                                {this.renderModifiedByInfo()}
                            </Paper>
                        </div>
                    </div>
                </Form>
            </Dialog >
        );
    }

    render() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>)
        }

        return (
            <div className={"pt-4 grey text-center" + (this.state.loading ? 'fadeOut' : 'fadeIn')} >
                <div className="container">
                    {this.renderForm()}
                </div>
            </div>
        );
    }
}

export default withPlanningSettings(LinkAgendaNew);